(function () {
 $(document).ready(function () {
  $(document).on("swell:setup", function () {
    if(spapi.authenticated) {
      SwellConfig.Redemption.cartRedemptions("#swell-redemption-options");
      SwellConfig.Redemption.cartRedemptionDropdown();
      SwellConfig.Redemption.cartRedemptionsShow();
      $(".swell-ring-cart").remove();
    }

    $('body').on('click', '#swell-redeem-btn', function()
    {
      $(".swell-copuon-error").hide();
      if(spapi.authenticated){
        if(beforeDiscountRedemption())
        {
          $(document).on("swell:cart:updated", function()
          {
            if(window.location.href.indexOf("cart") > -1) {
              window.location = "/cart";
            }
          });
          $("#swell-redeem-btn .btn__content").hide();
          $(".swell-lds-holder.swell-ring-btn").css("display","flex");
          redemptionOptionId = parseInt($("#swell-redemption-options").val());
          redemptionOption = swellAPI.findActiveRedemptionOptionById(redemptionOptionId);
          swellAPI.refreshCustomerDetails(function() {
            if(redemptionOption.amount <= spapi.customer.adjusted_points_balance)
            {
              result = swellAPI.buyMultipleWithPoints([redemptionOption], function(){});
            }
            else
            {
              $(".swell-lds-holder.swell-ring-btn").css("display","none");
              $("#swell-redeem-btn .btn__content").show();
              $(".swell-copuon-error").html("Sorry, you don't have enough points for this reward.");
              $(".swell-copuon-error").show();
            }
          });
        }
      }
    });

    Swell.Cart.items.forEach(function(item) {
      if (item.properties._swell_discount_type == "cart_fixed_amount") {
        redeemedRedemptionOption = swellAPI.findActiveRedemptionOptionById(item.properties._swell_redemption_option_id);
        $(".cart__content .cart__products").append('<div class="cart__product"><div class="cart__row"> <div class="o-layout o-layout--small u-flex u-flex--middle"> <div class="o-layout__item u-1/1 u-5/8@tab"> <div class="o-layout o-layout--tiny u-flex u-flex--middle"> <div class="o-layout__item u-1/3 u-1/3@tab"> <a href="javascript:void(0)" class="cart__product-image swell-product-image"> <div class="u-1/1 lazyloaded">'+redeemedRedemptionOption.prettyDiscount+'</div> </a> </div> <div class="o-layout__item u-2/3 u-2/3@tab"> <a href="javascript:void(0)"> <h3 class="cart__product-name">'+redeemedRedemptionOption.name+'</h3> </a> </div> </div> </div> <div class="o-layout__item u-2/3 u-2/8@tab"> <div class="js-qty"> <button disabled="disabled" type="button" class="js-qty__adjust js-qty__adjust--minus icon-fallback-text" data-id="" data-qty="8"> <span aria-hidden="true">−</span> <span class="u-hidden-visually">Reduce item quantity by one</span> </button> <input type="text" class="js-qty__num" value="1" min="" data-id="" aria-label="quantity" pattern="[0-9]*" name="" id="" step="1" disabled="disabled"> <button disabled="disabled" type="button" class="js-qty__adjust js-qty__adjust--plus" data-id="" data-qty="91"> <span aria-hidden="true">+</span> </button> </div> </div> <div class="o-layout__item u-1/3 u-1/8@tab"> <div class="cart-item__price"><span class="money">'+redeemedRedemptionOption.cost_text+'</span></div> </div> </div> <a href="javascript:void(0)" class="cart-item__remove icon-fallback swell-coupon-remove"> <i class="icon icon--close" aria-hidden="true"></i> <span class="icon-fallback__text">Remove</span> </a> </div></div>');
        // $("#CartContainer .ajaxcart__inner .ajaxcart__products").append('<div class="ajaxcart__product"> <div class="ajaxcart__row" data-line="2"> <div class="o-layout o-layout--tiny u-flex u-flex--middle"> <div class="o-layout__item u-1/1 u-6/10@tab"> <div class="o-layout o-layout--tiny u-flex u-flex--middle"> <div class="o-layout__item u-1/3 u-1/4@tab"> <a href="javascript:void(0)" class="ajaxcart__product-image"> <div class="u-1/1 lazyloaded">'+redeemedRedemptionOption.prettyDiscount+'</div> </a> </div> <div class="o-layout__item u-2/3 u-3/4@tab"> <a href="javascript:void(0)"> <h3 class="ajaxcart__product-name">'+redeemedRedemptionOption.name+'</h3> </a> </div> </div> </div> <div class="o-layout__item u-2/3 u-2/10@tab"> <div class="ajaxcart__qty"> <button disabled="disabled" type="button" class="ajaxcart__qty-adjust ajaxcart__qty--minus" data-id="" data-qty="" data-line=""> <span aria-hidden="true">−</span> </button> <input disabled="disabled" type="text" name="updates[]" class="ajaxcart__qty-num" value="1" min="0" data-id="" data-line="" aria-label="quantity" pattern="[0-9]*"> <button disabled="disabled" type="button" class="ajaxcart__qty-adjust ajaxcart__qty--plus" data-id="" data-line="" data-qty=""> <span aria-hidden="true">+</span> </button> </div> </div> <div class="o-layout__item u-1/3 u-2/10@tab"> <div class="ajaxcart-item__price"><span class="money">'+redeemedRedemptionOption.cost_text+'</span></div> </div> </div> </div> </div>');
        return
      }
    });

    $('body').on('click',".swell-coupon-remove", function() {
      $(document).on("swell:cart:updated", function(){
        if(window.location.href.indexOf("cart") > -1) {
          window.location = "/cart";
        }
        else{
          $(temp_holder).html(temp);
          spapi.$.confirm({
            title: "Redeemed!",
            content: "You have redeemed the discount!",
            type: "green",
            typeAnimated: true,
            useBootstrap: false,
            boxWidth: "400px",
            buttons: {
              ok: {
                text: "Ok",
                action: function () {
                }
              }
            }
          });
        }
      });
      $(".swell-coupon-remove").html('<div class="swell-lds-holder swell-ring-remove"><div class="swell-lds-dual-ring swell-ring-remove"></div></div>');
      swellAPI.removeRedemptionOptionIdFromCart(redeemedRedemptionOption.id, function(){});
    });

  });
 });
}).call(this);
  
//redemptions
(function() {
  window.SwellConfig = window.SwellConfig || {};

  SwellConfig.Redemption = {
    cartRedemptions: function(containerSelector) {
      var redemptions = spapi.activeRedemptionOptions;
      redemptions.forEach(function(redemption) {
        if(redemption.discount_type == "cart_fixed_amount") {
          $(containerSelector).append('<option value="'+ redemption.id +'" >'+redemption.name+'</option>');
        }
      });
    },
    cartRedemptionsShow: function () {
      $(".swell-checkout").show();
    },
    cartRedemptionDropdown: function () {
      $("#swell-redemption-options").prepend("<option value='choose'>Redeem your Bison Bucks for discounts</option>");
      $("#swell-redemption-options").val("choose");
      SwellConfig.Redemption.cartRedemptionDropdownUpdate();
      $("#swell-redemption-options").on('change', function()
      {
        SwellConfig.Redemption.cartRedemptionDropdownUpdate();
      });
    },
    cartRedemptionDropdownUpdate: function () {
      if($("#swell-redemption-options").val()=='choose'){
        $("#swell-redeem-btn").attr("disabled", "disabled");
        $("#swell-redeem-btn").css("opacity","0.8");
      }
      else{
        $("#swell-redeem-btn").removeAttr("disabled");
        $("#swell-redeem-btn").css("opacity","1");
      }
    }
  };

}).call(this);


function beforeDiscountRedemption(){
  var redeemedItemsInCart = 0;
  var regularItemsInCart = 0;
  var discountInCart = 0;
  
  if(Swell.Cart && Swell.Cart.items){
    var cart = Swell.Cart;
    
    $.each(cart.items, function(index, item){
      if(item.properties._swell_points_used){
        redeemedItemsInCart++;
      } else if(item.line_price > 0){
        regularItemsInCart++; 
      }
    });
    
    Swell.Cart.items.forEach(function(item) {
      if (item.properties._swell_discount_type == "cart_fixed_amount") {
        discountInCart++;
      }
    });
    if(discountInCart > 0){
      $(".swell-copuon-error").html("You already have a redeemed discount in your cart.")
      $(".swell-copuon-error").show();
      return false;
    }
    else if(regularItemsInCart == 0){
      spapi.$.confirm({
        title: "Oops!",
        content: "You must add a priced item in your cart to redeem points for a discount.",
        type: "red",
        typeAnimated: true,
        useBootstrap: false,
        boxWidth: "400px",
        buttons: {
          ok: {
            text: "Ok",
            action: function () {
            }
          }
        }
      });
      return false;
    }
    else{
      return true;
    }
  }
};